// extracted by mini-css-extract-plugin
module.exports = {"arrows-buttons":"DateTimeInput_arrows-buttons__10IZZ","icon":"DateTimeInput_icon__13Wov"};